import { Button } from '@/components/ui/button';
import { Send, Lock } from 'lucide-react';
import { useTalentDiscoveryMeter } from '@/hooks/useTalentDiscoveryMeter';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

interface TalentInviteSendButtonProps {
  onClick: () => void;
  isSending: boolean;
  jobSelected: boolean;
  t: (key: string) => string;
}

export function TalentInviteSendButton({ onClick, isSending, jobSelected, t }: TalentInviteSendButtonProps) {
  const { enabled: flagOn } = useFeatureFlag('talent_discovery_governance_v2');
  const { meter, isLoading } = useTalentDiscoveryMeter(flagOn);

  const blockedByQuota = flagOn && !isLoading && meter && !meter.can_send;

  if (blockedByQuota) {
    return (
      <Button disabled className="press-scale">
        <Lock className="w-4 h-4 me-2" />
        {t('hire.talent.meter.quotaExhausted')}
      </Button>
    );
  }

  return (
    <Button onClick={onClick} disabled={isSending || !jobSelected} className="press-scale">
      <Send className="w-4 h-4 me-2" />
      {t('hire.talent.sendInvite')}
    </Button>
  );
}
